import { LinkText } from '@/components/elements/LinkText'

export const QuestionItemList = [
  {
    questionTitle: 'Corporate Information',
    questionList: [
      {
        id: '1',
        questionContent: <>What is the company&apos;s management policy?</>,
        answerContent: (
          <>
            Please refer to &quot;
             <LinkText path="/en/ir/manage/" text="Management Policy" />
             .&quot;
          </>
        ),
      },
      {
        id: '2',
        questionContent: <>What is the origin of the company name?</>,
        answerContent: (
          <>
            TRIAL Company, Inc. is a retail business company which is main part of our group. 
            The name &quot;TRIAL&quot; implies &quot;TRIALs&quot; for difficulties. It represents 
            our will to continue to challenge the impossible for the future.
            <br />
            The name &quot;Company&quot; shows &quot;Companions&quot; aside a meaning of corporation. To take on &quot;TRIALs&quot; for difficulties with our &quot;Companions&quot; is what&apos;s into the name of TRIAL Company.
            <br />
            Please refer to &quot;
            <LinkText path="/en/company/overview/" text="Company Overview" />
            .&quot;
          </>
        ),
      },
      {
        id: '3',
        questionContent: <>What is the company&apos;s management philosophy?</>,
        answerContent: (
          <>
            We have established Purpose, Vision, and Values as our management philosophy.<br/>
            The birth episodes and the thoughts behind each item can be found in the &quot;
            <LinkText path="/en/company/philosophy/" text="Philosophy" />
            .&quot;
          </>
        ),
      },
      {
        id: '4',
        questionContent: <>When was the company founded?</>,
        answerContent: (
          <>
            TRIAL Company was established in 1974 as an antique dealer and recycle store in Fukuoka. 
            The company changed its name to TRIAL Company, Inc. in 1984 and established a pure holding 
            company, TRIAL Holdings, Inc. in 2015, with TRIAL Company, Inc. as its core operating company. 
            For more details, please refer to &quot;
            <LinkText path="/en/company/history/" text="History" />
            .&quot;
          </>
        ),
      },
    ],
  },
  {
    questionTitle: 'Our Business',
    questionList: [
      {
        id: '1',
        questionContent: <>What is the company&apos;s business overview?</>,
        answerContent: (
          <>
            We operate a distribution and retail business that operates discount stores throughout Japan, 
            and a retail AI business that develops and provides AI solutions that revolutionize the 
            distribution industry. For more details, please refer to &quot;
            <LinkText path="/en/business/" text="Our Business" />
            .&quot;
          </>
        ),
      },
    ],
  },
  {
    questionTitle: 'Corporate Governance',
    questionList: [
      {
        id: '1',
        questionContent: (
          <>What is the company&apos;s approach and structure of corporate governance?</>
        ),
        answerContent: (
          <>
            We believe that working together with our stakeholders, including shareholders and 
            investors, is the key to achieving sustainable growth as a company and increasing our 
            corporate value. To this end, it is important to ensure thorough compliance and 
            management transparency, as well as to realize speedy management through prompt 
            decision-making. For more details, please refer to &quot;
            <LinkText
              path="/en/ir/governance/basics/"
              text="Corporate Governance Basic Policy"
            />
            .&quot;
          </>
        ),
      },
    ],
  },
  {
    questionTitle: 'Financial Information',
    questionList: [
      {
        id: '1',
        questionContent: <>Does the company disclose monthly sales information?</>,
        answerContent: (
          <>
            The information is disclosed on or about the 10th of each month. 
            The latest monthly sales figures can be found in the &quot;
            <LinkText
              path="/en/ir/financial/monthly-sales/"
              text="Monthly Sales Report"
            />
            .&quot;
          </>
        ),
      },
      {
        id: '2',
        questionContent: <>Where can I find key financial indicators and performance trends?</>,
        answerContent: (
          <>
            Please refer to &quot;
            <LinkText path="/en/ir/financial/review/" text="Financial Highlights" />
            .&quot;
          </>
        ),
      },
    ],
  },
  {
    questionTitle: 'IR Library',
    questionList: [
      {
        id: '1',
        questionContent: <>Where can I find the latest financial information?</>,
        answerContent: (
          <>
            Please refer to &quot;
            <LinkText
              path="/en/ir/library/financial-announcement/"
              text="Financial Results Related Materials" 
            />
            .&quot; A digest of the financial results can be found in the &quot;
            <LinkText path="/en/ir/financial/review/" text="Financial Highlights"  />
            &quot; section.
          </>
        ),
      },
      {
        id: '2',
        questionContent: (
          <>
            Where can I find IR materials (financial statements, annual reports, etc.)?
          </>
        ),
        answerContent: (
          <>
            Please refer to &quot;
            <LinkText path="/en/ir/library/" text="IR Library" />
            .&quot;
          </>
        ),
      },
    ],
  },
  {
    questionTitle: 'Stock Information',
    questionList: [
      {
        id: '1',
        questionContent: <>How has the share price been performing?</>,
        answerContent: (
          <>
           Please refer to &quot;
            <LinkText path="/en/ir/stock/price/" text="Share Price Information" />
            .&quot;
          </>
        ),
      },
      {
        id: '2',
        questionContent: <>How many shares are in a trading unit?</>,
        answerContent: <>100 shares.</>,
      },
      {
        id: '3',
        questionContent: <>Which stock exchanges are you listed on?</>,
        answerContent: <>The company is listed on the Growth Market of the Tokyo Stock Exchange.</>,
      },
      {
        id: '4',
        questionContent: <>When was the stock listed?</>,
        answerContent: <>March 21, 2024.</>,
      },
      {
        id: '5',
        questionContent: <>What is your ticker?</>,
        answerContent: <>141A</>,
      },
      {
        id: '6',
        questionContent: <>How do I proceed stock administration?</>,
        answerContent: (
          <>
            Procedures differ depending on the type of account. Please refer to &quot;
            <LinkText path="/en/ir/stock/info/" text="Basic Information"  />
            .&quot;
          </>
        ),
      },
      // 2023年４月時点では非公開とのこと
      // {
      //   id: '7',
      //   questionContent: <>株主構成はどこで確認できますか？</>,
      //   answerContent: (
      //     <>
      //       大株主の一覧や所有者別分布状況等の情報については、
      //       <Link href="/ir/stock/situation/" passHref>
      //         <a>「株式の状況」</a>
      //       </Link>
      //       からご確認いただけます。
      //     </>
      //   ),
      // },
      {
        id: '8',
        questionContent: <>When is the general shareholders meeting?</>,
        answerContent: (
          <>
            The Annual General Meeting of Shareholders is scheduled to be held in late 
            September of each year.<br/>
            Please refer to &quot;
            <LinkText path="/en/ir/stock/meeting/" text="Shareholder&apos;s Meeting"  />
            &quot; for the Notice of Convocation of the General Meeting of Shareholders.
          </>
        ),
      },
      {
        id: '9',
        questionContent: <>How do I receive dividends?</>,
        answerContent: (
          <>
          The following methods are available for receiving dividends.<br/>
          - Receiving dividends in proportion to the number of shares recorded in the account 
          at the securities company (share number pro rata distribution method)<br/>
          Receiving all dividends through an account at a single financial institution 
          (registered dividend receipt account method)<br/>
          - Receiving dividends at the post office (dividend receipt method)<br/>
          - Receiving dividends at the counter of a post office, etc. (dividend receipt 
          method) <br/>
          - Designating an account transfer for each issue and receiving dividends at the 
          designated financial institution (individual issue designation method)<br/>
          <br/>
          * Please contact the securities company with which you have a trading account to 
          designate or change the method of receiving dividends. (For shareholders with 
          special accounts, please contact Mitsubishi UFJ Trust and Banking Corporation, 
          the administrator of special accounts.)<br/>
          * For details, please refer to 
            <LinkText
              path="https://www.tr.mufg.jp/daikou/kabu_qa_07.html"
              text=" the website of Mitsubishi UFJ Trust and Banking Corporation"
              target="_blank"
            />
            , our shareholder registry administrator.
          </>
        ),
      },
    ],
  },
  {
    questionTitle: 'Dividends and Shareholder Returns',
    questionList: [
      {
        id: '1',
        questionContent: <>What is your dividend policy?</>,
        answerContent: (
          <>
            Please refer to &quot;
            <LinkText path="/en/ir/stock/dividend/" text="Dividends and Shareholder Returns"  />
            .&quot;
          </>
        ),
      },
      {
        id: '2',
        questionContent: <>When is the record date for dividends?</>,
        answerContent: (
          <>
            June 30 of each year. If interim dividends are paid, the date is December 31. 
            For details, please refer to &quot;
            <LinkText path="/en/ir/stock/dividend/" text="Dividends and Shareholder Returns" />
            .&quot;
          </>
        ),
      },
      {
        id: '3',
        questionContent: <>Do you pay interim dividends?</>,
        answerContent: <>Not planned at this time.</>,
      },
      {
        id: '4',
        questionContent: <>Do you have a shareholder special benefit plan?</>,
        answerContent: <>There is no shareholder special benefit plan.</>,
      },
    ],
  },
  {
    questionTitle: 'IR calendar',
    questionList: [
      {
        id: '1',
        questionContent: <>When is your fiscal year end?</>,
        answerContent: <>Jun 30 every year.</>,
      },
      {
        id: '2',
        questionContent: <>What is your IR schedule?</>,
        answerContent: (
          <>
             Please refer to &quot;
            <LinkText path="/en/ir/calendar/" text="IR Calendar" />
            .&quot;
          </>
        ),
      },
    ],
  },
  {
    questionTitle: 'Inquiry',
    questionList: [
      {
        id: '1',
        questionContent: <>Where can I inquire about IR?</>,
        answerContent: (
          <>
            Please refer to &quot;
            <LinkText path="/en/contact/ir/" text="IR Inquiry" />
            .&quot;
          </>
        ),
      },
    ],
  },
]
